<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled || contracts.length === 1"
      class="form-control"
      @change="emit"
    >
      <option v-if="contracts.length !== 1" :value="null" disabled>Выберите договор</option>
      <option v-for="contract in contracts" :key="contract.id" :value="contract.id">
        {{ contract.number }} от {{ formatDate(contract.start_date) }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'
import moment from 'moment-timezone'

export default {
  name: 'ContractSelectInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Договор'
    },

    inputName: {
      default: 'contract_id'
    },

    inputHint: {
      default: undefined
    },

    contracts: {
      type: Array,
      default: () => []
    },

    timezone: {
      type: String,
      default: 'Europe/Moscow'
    }
  },

  methods: {
    formatDate(date) {
      return moment.tz(date, 'YYYY-MM-DD', this.timezone).format('DD.MM.YYYY')
    }
  },

  watch: {
    contracts: {
      immediate: true,
      handler(contracts) {
        if (contracts.length === 1) {
          this.inputValue = contracts[0].id
        }
      }
    }
  }
}
</script>
